module.exports = __webpack_public_path__ + "img/test_06.285296d0.png";